import React from "react";
import { Phone, Mail, MapPin, MessageSquareText } from "lucide-react";

export default function Contact() {
  return (
    <div className="max-w-5xl mx-auto px-6 md:px-10 py-16">
      <div className="text-mono-label">Contact</div>
      <h1 className="font-display font-black text-5xl md:text-6xl mt-4 tracking-tighter">Get in touch.</h1>
      <p className="mt-4 text-[#475569] max-w-2xl">The fastest way to reach us is the blue chat button in the corner — it goes straight to our team.</p>

      <div className="mt-14 grid grid-cols-1 md:grid-cols-3 gap-6">
        <a href="tel:+13478806834" data-testid="contact-phone" className="card-industrial p-8">
          <Phone className="w-8 h-8 text-brand" />
          <div className="mt-6 text-mono-label">Call</div>
          <div className="mt-2 font-display font-bold text-2xl">(347) 880-6834</div>
          <div className="mt-2 text-sm text-[#475569]">Mon–Sat · 8am–7pm</div>
        </a>
        <a href="mailto:tradesmechanical@yahoo.com" data-testid="contact-email" className="card-industrial p-8">
          <Mail className="w-8 h-8 text-brand" />
          <div className="mt-6 text-mono-label">Email</div>
          <div className="mt-2 font-display font-bold text-xl">tradesmechanical@yahoo.com</div>
          <div className="mt-2 text-sm text-[#475569]">Replies within 24h</div>
        </a>
        <div className="card-industrial p-8">
          <MessageSquareText className="w-8 h-8 text-brand" />
          <div className="mt-6 text-mono-label">Text (Fastest)</div>
          <div className="mt-2 font-display font-bold text-xl">Chat with us → replies fast</div>
          <div className="mt-2 text-sm text-[#475569]">Bottom-right of every page.</div>
        </div>
      </div>

      <div className="mt-14 card-industrial p-8">
        <MapPin className="w-8 h-8 text-brand" />
        <div className="mt-4 text-mono-label">Service Area</div>
        <h3 className="mt-2 font-display font-black text-3xl">Bronx · Westchester · Fairfield</h3>
        <p className="mt-4 text-[#475569] max-w-2xl">Serving the Bronx, all of Westchester County, NY, and Fairfield County, CT. Outside the area? Ask anyway — for the right job we'll travel.</p>
      </div>
    </div>
  );
}
